module.exports = __webpack_public_path__ + "img/courseCenter.0db0dbb2.png";